// 404 page rendered for unknown routes and for routes the current user
// is not authorized to access (e.g., /admin/signup-requests for non-
// Cade-internal users — Spec: docs/spec/core/part4-technical-architecture.md
// §14.10 "Visible only when currentUser.tenant.hasPlatformAdmin === true").

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: 56, margin: 0, lineHeight: 1, fontWeight: 600 }}>404</h1>
      <p style={{ marginTop: 16, color: 'var(--color-text-muted, #888)' }}>
        That page doesn&apos;t exist.
      </p>
      <Link
        to="/"
        style={{
          marginTop: 24,
          padding: '8px 16px',
          background: 'var(--color-accent)',
          color: 'var(--color-text-on-accent)',
          border: '1px solid var(--color-accent)',
          borderRadius: 6,
          textDecoration: 'none',
          fontSize: 14,
        }}
      >
        Back to chat
      </Link>
    </div>
  );
}
